import React, { useEffect } from 'react'
import type { BaseProvider } from '../../core/providers/base'
import type { AutoDimensions } from '../types/dimensions'
import { AnalyticsProvider } from '../../core/react'
import { TrackingManager } from '..'

interface Props {
  providers: BaseProvider[]
  initialDimensions?: AutoDimensions
  children: React.ReactNode
}

export const TrackingProvider: React.FC<Props> = ({
  providers,
  initialDimensions,
  children,
}) => {
  useEffect(() => {
    if (initialDimensions) {
      TrackingManager.setGlobalContext(initialDimensions)
    }
  }, [initialDimensions])

  return <AnalyticsProvider providers={providers}>{children}</AnalyticsProvider>
}
